import MegaOptionContainer from "../../../../Component/Forms/FormsControl/MegaOption/MegaOption"

const MegaOption = () => {
  return (
    <div className='page-body'>
      <MegaOptionContainer />
    </div>
  )
}

export default MegaOption